import React from 'react'

import { Table, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import { PurchaseOrderStatusLabel } from '../../../../components/purchaseOrder/status'
import { AmountText } from '../../../../core/components/widget/amountInline'

import Moment from 'moment'
import { DATE_FORMAT } from '../../../../core/utils/i18n-js'

const rowKey = (row) => row.id.toString()

const Widget = (props) => {
  const columns = [
    {
      title: 'ID #',
      dataIndex: 'id',
      render: (id, record) => {
        return (
          <Button
            onClick={() => props.viewMore(id)}
            ype='dashed'
            size='small'
            style={{ color: '#40a9ff', orderColor: '#40a9ff' }}
            icon={<EditOutlined />}
          >
            PO-{id}
          </Button>
        )
      }
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'name',
      render: (code, record) => <>{code}</>
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date, record) => <>{Moment(date).format(DATE_FORMAT)}</>
    },
    {
      title: 'Amount',
      dataIndex: 'amount_value',
      key: 'amountValue',
      render: (amountValue, record) => <AmountText value={amountValue} type={record.amount_type} />
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 140,
      render: (text) => <PurchaseOrderStatusLabel status={text} />
    }
  ]

  return (
    <>
      <Table columns={columns} dataSource={props.list} size='small' pagination={false} rowKey={rowKey} />
    </>
  )
}

export default Widget
